module.exports = __webpack_public_path__ + "img/ban3-2.95043d52.jpg";